<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>
  <mat-icon>gavel</mat-icon>
  Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} </strong>
</h2>

<ngx-spinner [zIndex]="100" name="spCaso" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<!-- FORMULARIO -->
<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">
  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      <mat-card appearance="outlined">
        <mat-card-header>
          <div mat-card-avatar>
            <mat-icon>delete</mat-icon>
          </div>
          <mat-card-title>Confirmar eliminación</mat-card-title>
          <mat-card-subtitle>Esta acción no se puede deshacer</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?</p>
        </mat-card-content>
      </mat-card>
    </ng-container>

    <ng-template #formTemplate>
      <mat-tab-group animationDuration="0ms">

        <!-- TAB: INFORMACIÓN BÁSICA -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>info</mat-icon>
            Información Básica
          </ng-template>

          <div class="container-fluid mt-3">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>assignment</mat-icon>
                </div>
                <mat-card-title>Datos Generales</mat-card-title>
                <mat-card-subtitle>Información principal del caso</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="row">
                  <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Caratula</mat-label>
                      <input matInput type="text" maxlength="200" style="text-transform: uppercase"
                        formControlName="Caratula" />
                      <mat-icon matPrefix>label</mat-icon>
                      <mat-error *ngIf="form.controls['Caratula'].hasError('required')">Este campo es
                        <strong>requerido</strong>.</mat-error>
                      <mat-error *ngIf="form.controls['Caratula'].hasError('maxlength')">Supero el largo
                        máximo.</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <ngx-spinner [zIndex]="-1" name="spTiposCaso" bdColor="rgba(255,255,255,0.8)" size="small"
                        color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                      <mat-label>Tipo Caso</mat-label>
                      <mat-select placeholder="Seleccione opción" formControlName="IdTipoCaso">
                        <mat-option [value]="tipoCaso.id" *ngFor="
                          let tipoCaso of tiposCaso;
                          let i = index;
                          trackBy: trackByItems
                        ">
                          {{ tipoCaso.descripcion }}
                        </mat-option>
                      </mat-select>
                      <mat-icon matPrefix>category</mat-icon>
                    </mat-form-field>
                  </div>

                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <ngx-spinner [zIndex]="-1" name="spEstadosCaso" bdColor="rgba(255,255,255,0.8)" size="small"
                        color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                      <mat-label>Estado Caso</mat-label>
                      <mat-select placeholder="Seleccione opción" formControlName="IdEstadoCaso">
                        <mat-option [value]="estadoCaso.id" *ngFor="
                          let estadoCaso of estadosCaso;
                          let i = index;
                          trackBy: trackByItems
                        ">
                          {{ estadoCaso.descripcion }}
                        </mat-option>
                      </mat-select>
                      <mat-icon matPrefix>flag</mat-icon>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-tab>

        <!-- TAB: FECHAS -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>event</mat-icon>
            Fechas
          </ng-template>

          <div class="container-fluid mt-3">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>schedule</mat-icon>
                </div>
                <mat-card-title>Fechas del Caso</mat-card-title>
                <mat-card-subtitle>Fechas de inicio y finalización</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Fecha Comienzo</mat-label>
                      <input matInput [matDatepicker]="pickerFechaComienzo" formControlName="FechaComienzo"
                        placeholder="MM/DD/YYYY" />
                      <mat-datepicker-toggle matIconSuffix [for]="pickerFechaComienzo"></mat-datepicker-toggle>
                      <mat-datepicker #pickerFechaComienzo></mat-datepicker>
                      <mat-icon matPrefix>play_arrow</mat-icon>
                      <mat-error *ngIf="form.controls['FechaComienzo'].hasError('required')">Este campo es
                        <strong>requerido</strong>.</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Fecha Finalización</mat-label>
                      <input matInput [matDatepicker]="pickerFechaFinalizacion" formControlName="FechaFinalizacion"
                        placeholder="MM/DD/YYYY" />
                      <mat-datepicker-toggle matIconSuffix [for]="pickerFechaFinalizacion"></mat-datepicker-toggle>
                      <mat-datepicker #pickerFechaFinalizacion></mat-datepicker>
                      <mat-icon matPrefix>stop</mat-icon>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-tab>

        <!-- TAB: DETALLES -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>description</mat-icon>
            Detalles
          </ng-template>

          <div class="container-fluid mt-3">
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>notes</mat-icon>
                </div>
                <mat-card-title>Descripción del Caso</mat-card-title>
                <mat-card-subtitle>Información adicional y observaciones</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="row">
                  <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Descripción</mat-label>
                      <textarea matInput #message name="Descripcion" formControlName="Descripcion"
                        rows="4" maxlength="2000"></textarea>
                      <mat-error *ngIf="form.controls['Descripcion'].hasError('maxlength')">Supero el largo
                        máximo.</mat-error>
                      <mat-hint align="start">Amplíe información sobre el caso</mat-hint>
                      <mat-hint align="end">{{ message.value.length }} / 2000</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-tab>

      </mat-tab-group>
    </ng-template>
  </form>
</mat-dialog-content>

<!-- VISTA DE LECTURA -->
<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">
  <div *ngIf="data.item">
    <mat-tab-group animationDuration="0ms">

      <!-- TAB: INFORMACIÓN DEL CASO -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>gavel</mat-icon>
          Información del Caso
        </ng-template>

        <div class="container-fluid mt-3">
          <div class="row">
            <!-- DATOS GENERALES -->
            <div class="col-12 col-lg-6">
              <mat-card appearance="outlined" class="mb-3">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>assignment</mat-icon>
                  </div>
                  <mat-card-title>Datos Generales</mat-card-title>
                  <mat-card-subtitle>Información principal del caso</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <mat-icon class="property-icon">label</mat-icon>
                    <span class="property-name">Carátula:</span>
                    <span class="property-value">{{
                      !isFalsy(data.item?.caratula) ? data.item?.caratula : ("Sin carátula" | uppercase)
                    }}</span>
                  </div>

                  <div class="property-row">
                    <mat-icon class="property-icon">category</mat-icon>
                    <span class="property-name">Tipo de caso:</span>
                    <span class="property-value">{{
                      data.item.tipoCaso ? data.item?.tipoCaso?.descripcion : ("Sin tipo" | titlecase)
                    }}</span>
                  </div>

                  <div class="property-row">
                    <mat-icon class="property-icon">flag</mat-icon>
                    <span class="property-name">Estado del caso:</span>
                    <span class="property-value">{{
                      data.item.estadoCaso ? data.item?.estadoCaso?.descripcion : ("Sin estado" | titlecase)
                    }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <!-- FECHAS -->
            <div class="col-12 col-lg-6">
              <mat-card appearance="outlined" class="mb-3">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>schedule</mat-icon>
                  </div>
                  <mat-card-title>Fechas</mat-card-title>
                  <mat-card-subtitle>Cronología del caso</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <mat-icon class="property-icon">play_arrow</mat-icon>
                    <span class="property-name">Fecha de inicio:</span>
                    <span class="property-value">{{ data.item?.fechaComienzo | date : "short" }}</span>
                  </div>

                  <div class="property-row">
                    <mat-icon class="property-icon">stop</mat-icon>
                    <span class="property-name">Fecha de finalización:</span>
                    <span class="property-value">{{ data.item?.fechaFinalizacion | date : "short" }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <!-- DESCRIPCIÓN -->
            <div class="col-12">
              <mat-card appearance="outlined" class="mb-3">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>description</mat-icon>
                  </div>
                  <mat-card-title>Descripción</mat-card-title>
                  <mat-card-subtitle>Detalles adicionales del caso</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <mat-icon class="property-icon">notes</mat-icon>
                    <span class="property-name">Descripción:</span>
                    <span class="property-value">{{
                      data.item?.descripcion ? data.item?.descripcion : "Sin descripción"
                    }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <!-- INFORMACIÓN DE AUDITORÍA -->
            <div class="col-12">
              <mat-card appearance="outlined" class="mb-3">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>history</mat-icon>
                  </div>
                  <mat-card-title>Información de Auditoría</mat-card-title>
                  <mat-card-subtitle>Historial de cambios</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="property-row">
                        <mat-icon class="property-icon">person_add</mat-icon>
                        <span class="property-name">Creado por:</span>
                        <span class="property-value">{{ data.item?.usuarioCreacion || "Sistema" }}</span>
                      </div>
                      <div class="property-row">
                        <mat-icon class="property-icon">access_time</mat-icon>
                        <span class="property-name">Fecha de creación:</span>
                        <span class="property-value">{{ data.item?.fechaCreacion | date : "short" }}</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="property-row">
                        <mat-icon class="property-icon">edit</mat-icon>
                        <span class="property-name">Modificado por:</span>
                        <span class="property-value">{{ data.item?.usuarioModificacion || "Sin modificaciones" }}</span>
                      </div>
                      <div class="property-row">
                        <mat-icon class="property-icon">update</mat-icon>
                        <span class="property-name">Última modificación:</span>
                        <span class="property-value">{{ data.item?.fechaModificacion | date : "short" }}</span>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- TAB: EXPEDIENTES -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>folder</mat-icon>
          Expedientes
        </ng-template>

        <div class="container-fluid mt-3">
          <div class="row">
            <div class="col-12">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>folder_open</mat-icon>
                  </div>
                  <mat-card-title>Expedientes Asociados</mat-card-title>
                  <mat-card-subtitle>Lista de expedientes relacionados al caso</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <ngx-spinner [zIndex]="100" name="spExpediente" bdColor="rgba(255,255,255,0.8)" size="default"
                    color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
                  </ngx-spinner>
                  <app-list-expediente-simple [expedientes]="expedientes"></app-list-expediente-simple>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>
</mat-dialog-content>

<!-- BOTONES DE ACCIÓN -->
<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid"
    (click)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Modificar"></app-button-save>

  <app-button-delete (click)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete>
</mat-dialog-actions>
